import React from 'react';
import { Link } from 'react-router-dom';
import Card from '../../common/Card';
import Button from '../../common/Button';
import { useServices } from '../../../hooks/useServices';
import './Services.css';

const DEFAULT_ICONS = {
  reiki: '✨',
  'reiki-intro': '🌿',
  'deep-release': '💫',
  tarot: '🔮',
  'soul-coaching': '🌟',
  chakra: '🧘‍♀️',
  'space-clearing': '🏡',
  'restorative-reiki': '☯️',
  'guided-ascension': '🌈'
};

const DEFAULT_IMAGES = {
  reiki: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=600&h=400&q=80&fit=crop',
  'reiki-intro': 'https://images.unsplash.com/photo-1602192509154-0b900ee1f851?w=600&h=400&q=80&fit=crop',
  'deep-release': 'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=600&h=400&q=80&fit=crop',
  tarot: 'https://images.unsplash.com/photo-1567016432779-094069958ea5?w=600&h=400&q=80&fit=crop',
  'soul-coaching': 'https://images.unsplash.com/photo-1499209974431-9dddcece7f88?w=600&h=400&q=80&fit=crop',
  chakra: 'https://images.unsplash.com/photo-1593811167562-9cef47bfc4d7?w=600&h=400&q=80&fit=crop',
  'space-clearing': 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=600&h=400&q=80&fit=crop',
  'restorative-reiki': 'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=600&h=400&q=80&fit=crop',
  'guided-ascension': 'https://images.unsplash.com/photo-1528715471579-d1bcf0ba5e83?w=600&h=400&q=80&fit=crop'
};

const Services = () => {
  const { services, loading, error } = useServices();

  const getIcon = (service) => {
    return service.icon || DEFAULT_ICONS[service.slug] || '✨';
  };

  const getImage = (service) => {
    return service.image || DEFAULT_IMAGES[service.slug] || DEFAULT_IMAGES.reiki;
  };

  if (loading) {
    return (
      <section id="services" className="section services">
        <div className="container">
          <div className="services__header text-center">
            <h2>Healing Services</h2>
            <p className="services__subtitle">Loading services...</p>
          </div>
        </div>
      </section>
    );
  }

  if (error) {
    console.error('Error loading services:', error);
  }

  return (
    <section id="services" className="section services">
      <div className="container">
        <div className="services__header text-center">
          <h2>Healing Services</h2>
          <p className="services__subtitle">
            Personalised holistic healing designed to support your unique journey
          </p>
        </div>

        <div className="services__grid">
          {services.map((service) => (
            <Card key={service.id} className="service-card">
              <div className="service-card__image-wrapper">
                <img
                  src={getImage(service)}
                  alt={service.name}
                  className="service-card__image"
                />
                <div className="service-card__icon">
                  {getIcon(service)}
                </div>
              </div>
              <div className="service-card__content">
                <h3 className="service-card__title">{service.name}</h3>
                <p className="service-card__tagline">{service.tagline}</p>
                <p className="service-card__description">
                  {service.description.substring(0, 120)}...
                </p>
                <div className="service-card__footer">
                  <div className="service-card__price">
                    <span className="price-label">Investment:</span>
                    <span className="price-amount">
                      {typeof service.price === 'number' ? `$${service.price} AUD` : service.price}
                    </span>
                  </div>
                  <Link to={`/services/${service.slug}`}>
                    <Button variant="text">Learn More →</Button>
                  </Link>
                </div>
              </div>
            </Card>
          ))}
        </div>

      </div>
    </section>
  );
};

export default Services;
